




































































































import { Component, Vue, PropSync } from "vue-property-decorator";
import { tiposBancoList } from "@/models/commons/TipoBancoModel";
import { ContaBancariaModel } from "@/models/commons/ContaBancariaModel";

@Component
export default class ContaBancaria extends Vue {
  @PropSync("contaBancaria")
  contaBancariaSynced!: ContaBancariaModel;

  listaBancos = tiposBancoList;
}
